<template>
  <div class="field">
    <label class="label">Min Seniority</label>
    <div class="control">
      <input
        class="input"
        type="text"
        placeholder="..."
        :value="value"
        @input="updateValue"
        @focusout="handleChange"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'PositionMinSeniority',
  props: {
    value: {
      type: [Number],
      required: true
    },
    positionId: {
      type: Number,
      required: true
    }
  },
  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    },
    async handleChange () {
      try {
        await this.$network_utils.updatePosition({ position_id: this.positionId, min_seniority: this.value })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
